export const normalizeInstagramProfile = (value: string): string | null => {
  if (!value.trim()) return null;
  const input = value.trim();
  let username = input.replace(/^@/, '');

  if (/^https?:\/\//i.test(input)) {
    try {
      const parsed = new URL(input);
      const host = parsed.hostname.toLowerCase().replace(/^www\./, '');
      const segments = parsed.pathname.split('/').filter(Boolean);
      if (host !== 'instagram.com' || segments.length !== 1) return null;
      username = segments[0];
    } catch {
      return null;
    }
  } else if (input.includes('/') || input.includes(':')) {
    return null;
  }

  if (!/^[A-Za-z0-9._]{1,30}$/.test(username)) return null;
  return `https://www.instagram.com/${username}`;
};
